import {
  PostOnboardingChecklist,
  PostOnboardingChecklistStepKey,
} from '~/types'

export const getChecklistStep = (
  checklist: PostOnboardingChecklist,
  key: PostOnboardingChecklistStepKey,
) => checklist.steps.find((step) => step.key === key)

export const isChecklistStepComplete = (
  checklist: PostOnboardingChecklist,
  key: PostOnboardingChecklistStepKey,
) => !!getChecklistStep(checklist, key)?.completedAt

/**
 * Whether the dashboard gives the checklist panel a slot. PageLayout sizes the
 * sidebar from the slot, not from what the slot renders, thus a finished
 * checklist must not get one.
 */
export const shouldShowChecklistPanel = (
  checklist: PostOnboardingChecklist | null,
) => !!checklist && !checklist.hidden && !checklist.completedAt
